module.exports = __webpack_public_path__ + "img/nba21.9dd30816.png";